import DocumentVerificationCrud from "../components/document-verification/DocumentVerificationCrud";

const DocumentVerificationPage = () => {
  return <DocumentVerificationCrud />;
};

export default DocumentVerificationPage;
